import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "appointments",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-marketing-engagement" */ "Admissions/features/MarketingEngagement/components/Appointments"
    ).then(m => m.default)
  ),
});
